// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'eu-west-2:41de6970-d8b5-4bd8-aeae-8e11c2f7ed41',
    'aws_cognito_region': 'eu-west-2',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'claimshandlingclient-hosting-mobilehub-613521401',
    'aws_content_delivery_bucket_region': 'eu-west-2',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd3oupccu6y3u3f.cloudfront.net',
    'aws_mandatory_sign_in': 'enable',
    'aws_mobile_analytics_app_id': 'bfcd665f8b2d44d4ae39cbb476486676',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'b6e58fef-03d2-4143-8437-161ca45dda27',
    'aws_project_name': 'claims-handling.client-web',
    'aws_project_region': 'eu-west-2',
    'aws_resource_name_prefix': 'claimshandlingclient-mobilehub-613521401',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'eu-west-2_EpxLbk3RH',
    'aws_user_pools_web_client_id': '5ok1kmjdvgmp5ogjik9iq1logs',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js